export default "__VITE_ASSET__5MKSgBbm__"